import ChangeProjectImageModal from './ChangeProjectImageModal'

export default ChangeProjectImageModal
